import React, {Component} from 'react';
import { Trans } from 'react-i18next';

import Dialog from '@material-ui/core/Dialog';
import DialogButton from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {createTheme} from '@material-ui/core/styles';
import {ThemeProvider} from '@material-ui/styles';

import i18n from '../resources/i18n';
import { properties } from '../resources/properties.js';

const theme = createTheme({
  palette: { primary: { 500: properties.BUTTON_THEME_COLOR } },
  overrides: { MuiButton: { containedPrimary: { color: 'white' } } }
});
const themeTitle = createTheme({
  palette: { primary: { 500: properties.TITLE_THEME_COLOR } },
  overrides: { MuiDialogTitle: { root: { backgroundColor: properties.TITLE_THEME_COLOR, color: 'white' } } }
});

class WizardNavigator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showAlertModal: false,
      showAlertModalError: false,
      showAlertModalSerie: false
    };
  }

  setStateGlobalSteps = (value) => (event) => {
    let {parentState} = this.props;
    if (((value === 2 && parentState.active === 1) || (value === 5 && parentState.active === 4) || (value === 12 && parentState.active === 11)) && (!document.getElementById('textAuthor').validity.valid || !document.getElementById('titleStep2').validity.valid  || (parentState.specialMapGeneration && (!document.getElementById('imagenCodigoBarras').validity.valid || !document.getElementById('textDepositoLegal').validity.valid || !document.getElementById('textISBN').validity.valid || !document.getElementById('textNipo').validity.valid)))) {
      //|| (value === 15 && parentState.active === 14)
      this.checkValidity(parentState.specialMapGeneration);
      this.setState({showAlertModal: true});
    } else if (value === 2 && parentState.active === 0 && (!(parentState.title && parentState.title.length) || !(parentState.author && parentState.author.length) || (parentState.specialMapGeneration && ( !(parentState.nipo && parentState.nipo.length) || !(parentState.isbn && parentState.isbn.length) || !(parentState.depositoLegal && parentState.depositoLegal.length) || !(parentState.codigoBarras && parentState.codigoBarras.length))))) {//desde Step1.js a Step3.js
      this.setState({showAlertModal: true});
      // } else if (((value === 1 && this.props.active === 0) || (value === 5 && this.props.active === 4)) && parentState.controlModal === 0) {
      //   this.setState({showAlertModalError: true});
    } else if (value === 11 && parentState.active === 10 && (window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta').getCountHojas() < 2)) {//desde Step1SS.js a Step2SS.js
      document.querySelector('.footerButtons .boton-add button.active[value^=add]').click();//Hacer click sobre la flecha de forma automática
      //this.setState({showAlertModal: true});//Necesario cambiar texto a "Generar mínimo de 2 hojas y entrar con el metodo normal"
    } else if (value === 12 && parentState.active === 10 && this.testSeriesAppliedParameters()) {//desde Step1SS.js a Step3SS.js
      this.setState({showAlertModalSerie: true});//Generar valores necesarios para cada hoja
    } else if (parentState.estado === 0) {
      this.setState({showAlertModalError: true})
    } else if (parentState.estado !== 0) {
      const {setParentStateSteps} = this.props;
      parentState.active = value;
      setParentStateSteps(parentState);
    }
  }
  checkValidity(specialMapGeneration){
    if (!document.getElementById('textAuthor').validity.valid) {
      document.getElementById('textAuthor').style.borderBottomColor = '#ff0000';
    } else {
      document.getElementById('textAuthor').style.borderBottomColor = 'black';
    }
    if (!document.getElementById('titleStep2').validity.valid) {
      document.getElementById('titleStep2').style.borderBottomColor = '#ff0000';
    } else {
      document.getElementById('titleStep2').style.borderBottomColor = 'black';
    }
    if(specialMapGeneration){
      if (!document.getElementById('imagenCodigoBarras').validity.valid) {
        document.getElementById('imagenCodigoBarras').style.borderBottomColor = '#ff0000';
      } else {
        document.getElementById('imagenCodigoBarras').style.borderBottomColor = 'black';
      }
      if (!document.getElementById('textDepositoLegal').validity.valid) {
        document.getElementById('textDepositoLegal').style.borderBottomColor = '#ff0000';
      } else {
        document.getElementById('textDepositoLegal').style.borderBottomColor = 'black';
      }
      if (!document.getElementById('textISBN').validity.valid) {
        document.getElementById('textISBN').style.borderBottomColor = '#ff0000';
      } else {
        document.getElementById('textISBN').style.borderBottomColor = 'black';
      }
      if (!document.getElementById('textNipo').validity.valid) {
        document.getElementById('textNipo').style.borderBottomColor = '#ff0000';
      } else {
        document.getElementById('textNipo').style.borderBottomColor = 'black';
      }
    }
  }
  handleCloseWizard = () => {
    this.setState({showAlertModal: false});
  }
  handleCloseWizardError = () => {
    this.setState({showAlertModalError: false});
  }
  handleCloseWizardSerie = () => {
    this.setState({showAlertModalSerie: false});
  }
  testSeriesAppliedParameters = () => {
    const {serImgC} = this.props.parentState;
    if(serImgC && serImgC.length>1){
      for(let i = 0; i<serImgC.length;i++){
        let aux = serImgC[i];
        if((aux.title && aux.title.length) || (aux.author && aux.author.length) || (this.props.parentState.specialMapGeneration && ( !(aux.nipo && aux.nipo.length) || !(aux.isbn && aux.isbn.length) || !(aux.depositoLegal && aux.depositoLegal.length) || !(aux.codigoBarras && aux.codigoBarras.length)))) return true;
      }
    } else {
      return true;
    }
    return false;
  }
  render() {
    const {
      firstDivClassName,
      secondDivClassName,
      textSecondDivClassName,
      labelClassNameTittle,
      textLabelTittle,
      labelClassNameDescription,
      textLabelDescription,
      pageToRender,
      parentState
    } = this.props;

    let traduccionInputs;
    let traduccionInputs2;
    if(parentState && parentState.specialMapGeneration){//Especial
      traduccionInputs = i18n.t('dialog.textFormError1Especial') || 'Para completar mapa especial, debe introducir el título, autor/a, NIPO, ISBN, Depósito Legal y código de barras.';
      traduccionInputs2 = i18n.t('dialog.noSeriesParametersEspecial') || 'No tiene todos los requisitos para entrar en esta página. Tiene que tener como mínimo 2 hojas y cada hoja tiene que tener el título, autor/a, NIPO, ISBN, Depósito Legal y código de barras introducidos.';
    } else {
      traduccionInputs = i18n.t('dialog.textFormError1') || 'Para completar el mapa debe introducir el título y el autor/a.';
      traduccionInputs2 = i18n.t('dialog.noSeriesParameters') || 'No tiene todos los requisitos para entrar en esta página. Tiene que tener como mínimo 2 hojas y cada hoja tiene que tener el título y el autor/a introducidos.';
    }

    return (<div className={firstDivClassName}>
      <div className={secondDivClassName} style={{
          cursor: 'pointer'
        }} onClick={this.setStateGlobalSteps(pageToRender)}>
        <i className={textSecondDivClassName}></i>
      </div>
      <label className={labelClassNameTittle} style={{
          cursor: 'pointer'
        }} onClick={this.setStateGlobalSteps(pageToRender)}>{textLabelTittle}</label>
      <label className={labelClassNameDescription}>{textLabelDescription}</label>
      <Dialog open={this.state.showAlertModal} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <ThemeProvider theme={themeTitle}>
          <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
        </ThemeProvider>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {traduccionInputs}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ThemeProvider theme={theme}>
            <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWizard}>
              <Trans i18nKey="dialog.accept">
                Aceptar
              </Trans>
            </DialogButton>
          </ThemeProvider>
        </DialogActions>
      </Dialog>
      <Dialog open={this.state.showAlertModalError} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <ThemeProvider theme={themeTitle}>
          <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
        </ThemeProvider>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
              <Trans i18nKey="dialog.noGeographicInformation">
                El área seleccionada no contiene información geográfica. Por favor seleccione un área correspondiente a España (Península, Canarias y Baleares).
              </Trans>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ThemeProvider theme={theme}>
            <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWizardError}>
              <Trans i18nKey="dialog.accept">
                Aceptar
              </Trans>
            </DialogButton>
          </ThemeProvider>
        </DialogActions>
      </Dialog>
      <Dialog open={this.state.showAlertModalSerie} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <ThemeProvider theme={themeTitle}>
          <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
        </ThemeProvider>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {traduccionInputs2}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ThemeProvider theme={theme}>
            <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWizardSerie}>
              <Trans i18nKey="dialog.accept">
                Aceptar
              </Trans>
            </DialogButton>
          </ThemeProvider>
        </DialogActions>
      </Dialog>
    </div>);
  }
}

export default WizardNavigator;
